import DoctorInfoSection from "../components/doctor-profile/DoctorInfoSection"
import ReviewsSection from "../components/doctor-profile/ReviewsSection"
import { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom"

const DoctorProfilePage = () => {

  const [doctorData, setDoctorData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const {id} = useParams()
useEffect(() => {
        window.scrollTo(0, 0)
        }, [])
  useEffect(() => {
    axios.get(`https://medizenapi.ir/v1/doctor/getDoctor?doctor_id=${id}`)
      .then(res => {
        if (res.data.response_status === "success") {
          setDoctorData(res.data.data);
        } else {
          setError(res.data.error_message || "خطا در دریافت اطلاعات پزشک");
        }
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setError(" دریافت اطلاعات پزشک");
        setLoading(false);
      });
  }, []);

  if (loading) return (
    <div className="w-full min-h-screen flex justify-center items-center py-20">
      <div className="flex flex-col justify-center items-center">
        <div className="w-12 h-12 border-4 border-aqua-700
        border-t-aqua rounded-full animate-spin"></div>
        <p className="mt-4 text-gray-700 text-lg font-medium">در حال بارگذاری...</p>
      </div>
    </div>
  );

  if (error) return <p
  className="w-full text-center pt-5"
  >{error}</p>;
  if (!doctorData || doctorData.length === 0) return <p>پزشک یافت نشد.</p>;

  const doctor = doctorData[0];

  return(
    <div className="flex justify-center bg-[#F6F6F6]">
      <div className="w-full md:px-0 md:w-[85%] mt-3 lg:mt-0
      flex flex-col xl:flex-row gap-5">
        <DoctorInfoSection doctor={doctor} />
        <ReviewsSection doctor={doctor} />
      </div>
    </div>
  )
}

export default DoctorProfilePage;
